// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
      config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  };

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20250815-p1.png',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20250815-p2.png',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20250815-p3.png',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20250815-p4.png',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20250815-p5.png?v=1755249650',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/2_528f34fe-a57e-4a48-91a5-3a69a1ab6e00.png?v=1757648263',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/2_c90a3b69-6d1d-40b5-a457-c9dab844ab5d.png?v=1757648262',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/2_bee17711-3414-4c80-9f7b-31ac5dcafd25.png?v=1757648262',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/2_77cdc345-cf95-41bb-a7d3-0838c66e0b88.png?v=1757648262',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/2_9f5953c6-ab67-478f-a7b3-bc3b62db2c68.png?v=1757648262',

    // // 手套
    // 'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20260310__img_4.jpg?v=1773131260',
    // 'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20260310__img_3.png?v=1773131260',
    // 'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20260310__img_2.jpg?v=1773131260',
    // 'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20260310__img_1.jpg?v=1773131260',
    // 'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20260310__img_5.jpg?v=1773131260',
    // 'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20260310__img_6.jpg?v=1773131260',
    // 'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20260310__img_10.jpg?v=1773131260',
    // 'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20260310__img_7.jpg?v=1773131260',
    // 'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20260310__img_8.png?v=1773131260',
    // 'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/20260310__img_9.jpg?v=1773131260',

    // 弹力带
    "https://cdn.shopify.com/s/files/1/0557/8925/6837/files/1_6eb20dcf-62a0-4801-8728-4058b67d71f9.png?v=1764573627",
    "https://cdn.shopify.com/s/files/1/0557/8925/6837/files/1_c87610d7-9c0a-4e2c-b8d5-1f8aef36b106.png?v=1764573628",
    "https://cdn.shopify.com/s/files/1/0557/8925/6837/files/1_7600c18f-32e8-4f32-98f8-cf2d30b07f9c.png?v=1764573627",
    "https://cdn.shopify.com/s/files/1/0557/8925/6837/files/1_ea5e0a62-3753-4ec4-b782-7827353366d6.png?v=1764573627",
    "https://cdn.shopify.com/s/files/1/0557/8925/6837/files/1_82dad2b8-6205-4159-844b-8b9107ae09fb.png?v=1764573627",

    "https://cdn.shopify.com/s/files/1/0557/8925/6837/files/1_fe619933-c6cf-4791-b288-378b95cb16e5.png?v=1764573627",
    "https://cdn.shopify.com/s/files/1/0557/8925/6837/files/1_fb958ab5-6e47-49a8-a49e-1086076858bf.png?v=1764573627",
    "https://cdn.shopify.com/s/files/1/0557/8925/6837/files/1_7701b27f-498e-40f8-b6d0-0e62924acb2b.png?v=1764573627",
    "https://cdn.shopify.com/s/files/1/0557/8925/6837/files/1_30d436de-f689-4e0c-98b3-b1ac533d5e69.png?v=1764573627",
    "https://cdn.shopify.com/s/files/1/0557/8925/6837/files/1_7b7b7897-afb3-4914-811f-7acf6d2cb1b3.png?v=1764573627",


  ]

  preloadImages(spImgList)

  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination",
      clickable: true,
    },
  });
  const prods = window.product
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  let style = $('#sp-number div.active').attr('data-val')
  let size = $('#sp-size div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == style && item.option3 == size)[0]
}
function changePrice(){
  let num = $('#calcNumber').val()
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
//   price = (price + '').replace('.', ',')
//   compare = (compare + '').replace('.', ',')
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  $(".product-part .price-group .sp-row span").html(off_font);
}
$('.sp-btn-style').on('click',function(){
  let id = getCur().id
  let num = $("#calcNumber").val();
  window.location.href = '/cart/' + id + ':' + num
})
// 弹窗 start
   var main_id = "";
    $('.emitCheckout').click(function(){
      console.log('1111')
      main_id = getCur().id
      // main_id = $(this).siblings('.select_span').find('span.on').data('id')
      // window.location.href = "/cart/" + id + ":1"
    })

  function getPopProdId(){
    let selectVals = [];
   $('.overbuy_wrap .sp-subopt.active').each(function(){
      selectVals.push($(this).data('val'))
    })

    let cur = popProduct.filter(item => {
      let option1 = selectVals[0];
      let option2 = null;
      let option3 = null;
      if(selectVals[1]){
        option2 = selectVals[1];
      }
      if(selectVals[2]){
        option3 = selectVals[2];
      }

      
      return item.option1 == option1 && item.option2 == option2 && item.option3 == option3
    })

 
    
    return cur[0];
  }

  $('.overbuy-select div').click(function(){
     $(this).siblings().removeClass('active')
     $(this).addClass('active')
    let cur = getPopProdId();
    
    if(cur){
      $(".main-btn").text('GET 10% oFF').removeClass("overbuy_disabled")
      let _price = parseFloat(cur.price / 100).toFixed(2);
      let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(2);
  
      $('.overbuy_price span').eq(0).html('£' + _price);
      $('.overbuy_price span').eq(1).html('£' + _compare_at_price);
    }else{
      $(".main-btn").text("Unavailable").addClass("overbuy_disabled")
    }
    
  })

  


  window.emitSubmit = function(_type){
    let num = $('#calcNumber').val()
     if(_type == 'all'){
      // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
      let _id = getPopProdId()?.id;
       if(!_id) return
      console.log(_id)
       
      window.location.href = `/cart/${main_id}:${num},${_id}:1`
    }else{
      window.location.href = `/cart/${main_id}:${num}`
    }
  }



  // 弹窗 end

  $(".sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    // 找到当前点击的选项所在的商品区域
    let $currentProduct = $(this).closest('.product-part');
    
    // 只获取当前商品区域内的选项状态
    let colorOptions = $currentProduct.find("#sp-color .sp-option.active").index();
    let numberOptions = $currentProduct.find("#sp-number .sp-option.active").index();
    let sizeOptions = $currentProduct.find("#sp-size .sp-option.active").index();
    // if (sizeOptions) {
    //   $(".product-part .sp-img-p").css({
    //     height: "559px"
    //   })
    // }else {
    //    $(".product-part .sp-img-p").css({
    //     height: "489px"
    //   })
    // }
    let _index = colorOptions + numberOptions * 5 + sizeOptions * 10;
    $currentProduct.find(".sp-img-p").attr("src", spImgList[_index]);
    if(numberOptions == 0) {
      $currentProduct.find(".sp-free").hide();
    } else {
      $currentProduct.find(".sp-free").show();
    }

    if (sizeOptions == 1) {
      $('.product-part .sp-img-p').css({
        height: '100%'
      })
    } else {
      $('.product-part .sp-img-p').css({
        height: '489px'
      })
    }

    if(colorOptions == 0){
      $(".product-part .sp-free").css("top", "237px");
      $(".product-part .sp-free").css("right", "224px");
    } else if(colorOptions == 1){
      $(".product-part .sp-free").css("top", "260px");
      $(".product-part .sp-free").css("right", "232px");
    } else if(colorOptions == 2){
      $(".product-part .sp-free").css("top", "260px");
      $(".product-part .sp-free").css("right", "245px");
    } else if(colorOptions == 3){
      $(".product-part .sp-free").css("top", "260px");
      $(".product-part .sp-free").css("right", "242px");
    }else{
      $(".product-part .sp-free").css("top", "389px");
      $(".product-part .sp-free").css("right", "230px");
    }
    changePrice()
  });

  $(".sp-reduce, .sp-add").click(function () {
    // 找到当前按钮所在的商品区域（如 .product-part）
    let $product = $(this).closest('.product-part');
    // 找到数量 input
    let $input = $(this).siblings("input");
    let num = Number($input.val());
    if ($(this).hasClass("sp-reduce")) {
      num = Math.max(1, num - 1);
    } else {
      num = num + 1;
    }
    $input.val(num);
    changePrice()
  });

  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    $(".sp-header-top .sp-cart .num").show();
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-header-top .sp-cart").removeClass("on");
    }, 500);
  });

  $(".product-part .cart-btn").click(function () {
    $(".sp-cart .num").addClass("sp-gray");
    let data = {
      id: getCur().id,
      quantity: $("#calcNumber").val()
    };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    success: function () {
      $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
        $("#cardNum").html(result.item_count);
      });
    },
    dataType: "json",
  });
    // 找到当前商品区域
    let $product = $(this).closest('.product-part');
    // // 找到当前区域的数量 input
    // let input = Number($product.find("input[type='number']").val());
    // // 购物车数量（如果全局共用就不变）
    // let number = Number($("#cardNum").html());
    // $("#cardNum").html(number + input);

    // 当前区域的图片
    var img = $product.find(".sp-img-p");
    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $product.append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top: finish[0].offsetTop,
        left: finish[0].offsetLeft + finish.width() / 3,
        width: 50,
        height: 50,
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
});

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    $('.selectl span').click(function () {
      $(this).addClass("on").siblings().removeClass("on");
    })

    $(".selectl span").click(function () {
      $(this).addClass("on").siblings().removeClass("on");
    });

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top: offsetTop * $("div#root").css("zoom") - 240 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }



  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-detail");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }



}

mainRender();

